const MESSENGER_OPERATIONS = {
  LOAD_CHANNEL_MESSAGES: 'load_channel_messages',
  CHANNEL_CATALOG_CIDS_MISSING: 'channel_catalog_cids_missing',
  CHANNEL_CATALOG_CACHE_MISS: 'channel_catalog_cache_miss',
  CHANNEL_CATALOG_SHADOW_DIVERGENCE: 'channel_catalog_shadow_divergence',
  ASSIGN_INQUIRY: 'assign_inquiry',
  GET_DUPLICATE_CONTACTS: 'get_duplicate_contacts',
  GET_AGENTS_CHAT: 'get_agents_chat',
};

const WHATSAPP_OPERATIONS = {
  GET_WHATSAPP_SLOTS: 'get_whatsapp_slots',
  GET_AVAILABLE_SLOT: 'get_available_slot',
  GET_SLOTS_AVAILABILITY: 'get_slots_availability',
  GET_WHATSAPP_SLOT: 'get_whatsapp_slot',
  GET_AVAILABLE_BRANCHES: 'get_available_branches',
  GET_AVAILABLE_AGENTS: 'get_available_agents',
  CREATE_WHATSAPP_SLOT: 'create_whatsapp_slot',
  ASSIGN_WHATSAPP_SLOT: 'assign_whatsapp_slot',
  UNASSIGN_WHATSAPP_SLOT: 'unassign_whatsapp_slot',
  UNLINK_WHATSAPP_SLOT: 'unlink_whatsapp_slot',
  LINK_CLOUD_API_NUMBER: 'link_cloud_api_number',
  GET_CLOUD_API_PHONE_NUMBERS: 'get_cloud_api_phone_numbers',
  GET_CLOUD_API_CONNECTION_STATUS: 'get_cloud_api_connection_status',
  UNLINK_CLOUD_API_ACCOUNT: 'unlink_cloud_api_account',
  GET_WHATSAPP_QRCODE: 'get_whatsapp_qrcode',
  GET_WHATSAPP_IS_LINKED: 'get_whatsapp_is_linked',
  DESYNCHRONIZE_WHATSAPP: 'desynchronize_whatsapp',
  GET_BRANCHES: 'get_branches',
  PATCH_BRANCH_PHONE: 'patch_branch_phone',
  GET_WEBSOCKET_ACCESS_TOKEN: 'get_websocket_access_token',
  GET_CONTACT_CHAT_OR_SENDER: 'get_contact_chat_or_sender',
  GET_CHANNEL_REPLY_CAPABILITY: 'get_channel_reply_capability',
  ACCEPT_CHANNEL: 'accept_channel',
  SEND_RENDERED_TEMPLATE_MESSAGE: 'send_rendered_template_message',
  BLOCK_CHANNEL: 'block_channel',
};

const CHANNEL_QUERY_PATH = {
  STREAM_DIRECT: 'stream-direct',
  STREAM_AFTER_TOKKO_API: 'stream-after-tokko-api',
};

export { CHANNEL_QUERY_PATH, MESSENGER_OPERATIONS, WHATSAPP_OPERATIONS };
